export const CATEGORIES = {
  START_QUALIFY: 'Start Qualify',
  MINDSET_QUALIFY: 'Mindset Qualify',
  MINDSET_REPATH_NOT_READY: 'Mindset Repath Not Ready',

  GENERAL_EDUCATION: 'General Education',

  GENERAL_EDUCATION_REPATH_NOT_READY: 'Gen Ed Repath Not Ready', // legacy
  GEN_ED_REPATH_PASSED_ALL: 'Gen Ed Repath Passed All',

  ENTRANCE_EXAM: 'Entrance Exam (TEAS)',
  REPATH_PASSED_ENTRANCE_EXAM: 'Repath Passed Entrance Exam',

  CORE_NURSING_COURSES: 'Core Nursing Courses', // legacy
  CORE_RN_COURSES: 'Core RN Courses',
  REPATH_PASSED_CORE_RN_COURSES: 'Repath Passed RN Courses',

  LICENSURE_EXAM: 'Licensure Exam (NCLEX)', // legacy
  EXIT_EXAM: 'Exit Exam',
  REPATH_PASSED_EXIT_EXAM: 'Repath Passed Exit Exam',

  RESULT_QUALIFY: 'Results Qualify',

  BP_INFO: 'BP Info',
  BP_PRE_BUY: 'BP Pre-buy',
  BP_PRE_BUY_YES: 'BP Pre-buyYes',
  BP_PRE_BUY_NO: 'BP Pre-buyNo',

  READINESS: 'Readiness',
  READINESS_APPT_CONFIRMED: 'Readiness Appt Confirmed',
  READY_ASAP: 'Ready ASAP',

  BP_PRE_BUY_PURCHASED: 'BP Pre-Buy Purchased',

  BP_PRE_BUY_RES_MEET: 'BP Pre-Buy Res-Meet',
  BP_PRE_BUY_RES_SCHEDULE: 'BP Pre-Buy Res-Schedule',
  BP_PRE_BUY_LEARN: 'BP Prebuy Learn',

  BP_PRE_BUY_RES_CONFIRMED: 'BP Pre-Buy Res-Confirmed',
};
